<template>
  <!--   场地管理－优惠券管理 - 分享券使用记录 -->
  <div>
    <content-view>
      <div slot="header">
        <a-form :form="form" layout="inline" class="store-one-form">
            <a-form-item label="分享者账号">
                <a-input placeholder="请输入" v-decorator="['userAccount']"></a-input>
            </a-form-item>
            <a-form-item label="领取者账号">
                <a-input placeholder="请输入" v-decorator="['recipientAccount']"></a-input>
            </a-form-item>
            <a-form-item label="状态">
                <a-select allowClear placeholder="请选择" v-decorator="['state']">
                    <a-select-option value="0">未送达</a-select-option>
                    <a-select-option value="1">已送达</a-select-option>
                    <a-select-option value="2">已使用</a-select-option>
                    <a-select-option value="4">已失效</a-select-option>
                    <a-select-option value="5">已禁用</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="分享时间">
                <a-range-picker
                    style="width:282px"
                    format="YYYY-MM-DD"
                    v-decorator="['shareTime']"
                />
            </a-form-item>
            <a-form-item label="送达时间">
                <a-range-picker
                    style="width:282px"
                    format="YYYY-MM-DD"
                    v-decorator="['pickUpTime']"
                />
            </a-form-item>
            <a-form-item label="被使用时间">
                <a-range-picker
                    style="width:282px"
                    format="YYYY-MM-DD"
                    v-decorator="['usageTime']"
                />
            </a-form-item>
            <a-form-item class="wrap-header-button">
                <a-button @click="search" class="mr8" type="primary">筛选</a-button>
                <a-button @click="handleReset">重置</a-button>
            </a-form-item>
        </a-form>
      </div>

      <div class="container">
        <p class="trade-record_title mb8">
            <a-icon type="info-circle" style="padding-right: 8px;color: #FFBF00;margin-top: 2px;"/>优惠券名称：{{$route.query.name}}
        </p>
        <a-table
          bordered
          :dataSource="dataSource"
          :columns="columns"
          :pagination="pagination"
          @change="changePage"
          :rowKey="(record,index) => index"
        >
          <span slot="index" slot-scope="a,item,i">{{i+1}}</span>
          <span slot="state" slot-scope="state">{{['未送达','已送达','已使用','','已失效','已禁用'][state]}}</span>
          <span slot="usageTime" slot-scope="usageTime">{{usageTime ? usageTime : "-"}}</span>
          <span slot="action" slot-scope="a,row">
                <a-popconfirm
                    v-if="row.state == 5"
                    title="确认取消禁用吗？"
                    @confirm="couponState(row.id,row.state)"
                    >
                    <a class="text-primary">取消禁用</a>
                </a-popconfirm>
                <a-popconfirm
                    v-else-if="row.state == 1"
                    title="确认禁用吗？"
                    @confirm="couponState(row.id,row.state)"
                    >
                    <a class="text-primary">禁用</a>
                </a-popconfirm>
                <span v-else class="text-disabled">禁用</span>
          </span>
        </a-table>
      </div>
    </content-view>
  </div>
</template>

<script type="text/javascript">
    import moment from "moment";
    import { constants } from "fs";
    export default {
        name: "coupon",
        components: {},
        props: {},
        data() {
            return {
                dataSource: [],
                columns,
                // 分页
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                }
            };
        },
        methods: {
            handleReset() {
                this.form.resetFields();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            //获取列表
            getList() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    values.id = this.$route.query.id
                    const pickUpTime = values['pickUpTime'] ? values['pickUpTime'] : []
                    values.pickUpTime = pickUpTime.length > 0 ? pickUpTime[0].format('YYYY-MM-DD 00:00:00') : ''
                    values.pickUpEndTime = pickUpTime.length > 0 ? pickUpTime[1].format('YYYY-MM-DD 23:59:59') : ''

                    const usageTime = values['usageTime'] ? values['usageTime'] : []
                    values.usageTime = usageTime.length > 0 ? usageTime[0].format('YYYY-MM-DD 00:00:00') : ''
                    values.usageEndTime = usageTime.length > 0 ? usageTime[1].format('YYYY-MM-DD 23:59:59') : ''

                    const shareTime = values['shareTime'] ? values['shareTime'] : []
                    values.shareTime = usageTime.length > 0 ? usageTime[0].format('YYYY-MM-DD 00:00:00') : ''
                    values.shareEndTime = shareTime.length > 0 ? shareTime[1].format('YYYY-MM-DD 23:59:59') : ''
                    this.$api.totalPlatform
                        .distribution2User({
                            body: Object.assign(values, {
                                pageNum: this.pagination.current,
                                pageSize: this.pagination.pageSize
                            })
                        })
                        .then(res => {
                            this.dataSource = res.data
                            this.pagination.total = res.total
                        });
                });
            },
            couponState(id,state) {
                this.$api.totalPlatform.couponState({
                    body: {id: id, forbidden: state === 5 ? 0 : 1}
                })
                .then(res => {
                    this.$message.success('操作成功',2)
                    this.getList()
                })
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        mounted() {
            this.getList();
        }
    };
    const columns = [
    {
        title: "序号",
        dataIndex: "index",
        scopedSlots: { customRender: "index" }
    },
    {
        title: "分享者账号",
        dataIndex: "userAccount"
    },
    {
        title: "领取者账号",
        dataIndex: "recipientAccount"
    },
    {
        title: "领取时间",
        dataIndex: "pickUpTime"
    },
    {
        title: "使用时间",
        dataIndex: "usageTime",
        scopedSlots: { customRender: "usageTime" }
    },
    {
        title: "状态",
        dataIndex: "state",
        scopedSlots: { customRender: "state" }
    },
    {
        title: "操作",
        dataIndex: "action",
        scopedSlots: { customRender: "action" }
    }];
</script>
<style lang="scss">
.container {
  background: #fff;
}
</style>